import {theme} from '@/theme/theme'

export enum SnackbarType {
  info = 'info',
  error = 'error',
  success = 'success',
}

export const SnackbarTypeToBackgroundColor = {
  [SnackbarType.info]: theme.palette.gray[600],
  [SnackbarType.error]: theme.palette.error.main,
  [SnackbarType.success]: theme.palette.green[500],
}

export const SNACKBAR_AUTO_DISMISS = 3000
